import { theme } from "antd";
import { EDIT_COLOR } from "../../FloorPlanModal/utils/constants";

/**
 * The neutral look shared by the canvas controls (圖層 trigger and panel, the
 * blank-canvas hint). It never follows the company theme: the themes restyle
 * buttons, fonts and antd colours globally, and these controls must read the
 * same on all of them. The one accent is the fixed 編輯模式 blue.
 */
export const ACCENT = EDIT_COLOR;

// antd's own default font stack, so a cursive or serif theme font does not
// reach the controls (no font is loaded for this).
const { fontFamily } = theme.getDesignToken();

export const INK = "rgba(0, 0, 0, 0.88)";
export const INK_SECONDARY = "rgba(0, 0, 0, 0.55)";
export const SURFACE = "#ffffff";
export const LINE = "#d9d9d9";
export const DIVIDER = "#f0f0f0";
export const OVERLAY_SHADOW = "0 1px 4px rgba(0, 0, 0, 0.15)";

/** Resets what the themes push onto text through inheritance. */
export const neutralText = {
  fontFamily,
  fontSize: 13,
  letterSpacing: "normal",
  textTransform: "none",
  color: INK,
};

/**
 * antd components inside the panel start from antd's defaults again
 * (`inherit: false` drops the theme's grey/pink primary, dark algorithm and
 * font), with the fixed accent as primary.
 */
export const NEUTRAL_THEME = {
  inherit: false,
  token: { colorPrimary: ACCENT, fontFamily },
};

/** Keeps a press inside a control from panning or clicking the canvas. */
export const stopPropagation = (event) => event.stopPropagation();

/** Enter/Space on a role="button" element, like a native button. */
export const onActivateKey = (activate) => (event) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    activate(event);
  }
};
